// extracted by mini-css-extract-plugin
export default {"mainWrapper":"features_mainWrapper__B+Rp7","featureList":"features_featureList__iXNbl","description":"features_description__LC9Rh"};